import { useState } from "react";

const WhatsAppPopup = () => {
	const [show, setShow] = useState(true);

	if (!show) return null;

	return (
		<div style={styles.overlay}>
			<div style={styles.popup}>
				{/* Close Button */}
				<button style={styles.closeBtn} onClick={() => setShow(false)}>
					✖
				</button>

				{/* Clickable Image */}
				<a
					href="https://whatsapp.com/channel/0029Vb6gqr25PO15p0S6Fc3Z" // 🔥 replace with your WhatsApp link
					target="_blank"
					rel="noopener noreferrer"
				>
					<img src={'whats-app-pop-up.jpg'} alt="WhatsApp" style={styles.image} />
				</a>
			</div>
		</div>
	);
};

const styles = {
	overlay: {
		position: "fixed",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
		background: "rgba(0,0,0,0.5)",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		zIndex: 9999,
	},
	popup: {
		position: "relative",
		background: "#fff",
		padding: "10px",
		borderRadius: "10px",
	},
	closeBtn: {
		position: "absolute",
		top: "10px",
		right: "10px",   // 👈 moved left from -10px
		// background: "red",
		color: "#fff",
		fontSize: "8px",
		border: "none",
		borderRadius: "50%",
		width: "20px",
		height: "20px",
		cursor: "pointer",
	},
	image: {
		maxWidth: "300px",
		borderRadius: "10px",
	},
};

export default WhatsAppPopup;